import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { PAGE_NAME } from '../../../monitoring';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { SUPPORTED_ACTIONS } from './constants';
import UserActivationModalLazy from './UserActivationModalWrapperLazy';

const BASE_KEY = 'freelancer_page.user_activation_modal';

interface UserActivationModalProps {
    isOpen: boolean;
    onClose: () => void;
    action: SUPPORTED_ACTIONS;
}

const UserActivationModalWrapper = ({
    isOpen,
    onClose,
    action = SUPPORTED_ACTIONS.CONTACT_SELLER,
}: UserActivationModalProps) => {
    const { pathParameters } = getContext();
    const { isLoggedIn } = useFreelancerPageContext();
    const { username: sellerUsername } = pathParameters || { username: '' };
    const description = <I18n k={`${BASE_KEY}.${action}.description`} params={{ sellerUsername }} />;
    return (
        <>
            {isLoggedIn && (
                <UserActivationModalLazy
                    isOpen={isOpen}
                    onClose={onClose}
                    pageName={PAGE_NAME}
                    description={description}
                />
            )}
        </>
    );
};

export default UserActivationModalWrapper;
